import React from 'react';

interface OperationsIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const HomeIcon: React.FC<OperationsIconProps> = ({ color = '#111928', ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.625 19.4688H13.5313C12.5313 19.4688 11.6875 18.6562 11.6875 17.625V14.3125C11.6875 14.0625 11.5 13.875 11.25 13.875H8.75C8.5 13.875 8.3125 14.0625 8.3125 14.3125V17.625C8.3125 18.6562 7.5 19.4688 6.46875 19.4688H2.375C1.375 19.4688 0.53125 18.6562 0.53125 17.625V7.09375C0.53125 6.5625 0.78125 6.09375 1.21875 5.8125L9.1875 0.78125C9.6875 0.46875 10.3125 0.46875 10.7813 0.78125L18.75 5.84375C19.1875 6.125 19.4375 6.59375 19.4375 7.125V17.625C19.4688 18.625 18.625 19.4688 17.625 19.4688ZM8.75 12.4688H11.25C12.2813 12.4688 13.0938 13.2812 13.0938 14.3125V17.625C13.0938 17.875 13.2813 18.0625 13.5313 18.0625H17.625C17.875 18.0625 18.0625 17.875 18.0625 17.625V7.09375C18.0625 7.0625 18.0313 7.03125 18.0313 7L10.0312 1.96875C10 1.9375 9.96875 1.9375 9.9375 1.96875L2 7C1.96875 7.03125 1.9375 7.0625 1.9375 7.09375V17.625C1.9375 17.875 2.125 18.0625 2.375 18.0625H6.46875C6.71875 18.0625 6.90625 17.875 6.90625 17.625V14.3125C6.90625 13.3125 7.71875 12.4688 8.75 12.4688Z"
        fill={color}
      />
    </svg>
  );
};

export default HomeIcon;
